// HelpSupport — the "Need help?" strip on the Help & Training page (ticket 212).
// Two ways to reach us: the feedback form (same dialog as the user menu) and a
// "Contact support" email link. The address comes from REACT_APP_CONTACT_EMAIL;
// with it unset the link is hidden, never replaced by a literal.
import React, { useState } from 'react';
import { LifeBuoy, Mail, MessageSquare } from 'lucide-react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import FeedbackDialog from '../FeedbackDialog';

const CONTACT_EMAIL = (process.env.REACT_APP_CONTACT_EMAIL || '').trim();

export default function HelpSupport({ contactEmail = CONTACT_EMAIL }) {
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  return (
    <Card className="p-4 md:p-5 mb-6 flex flex-col md:flex-row md:items-center gap-3" data-testid="help-support">
      <div className="flex items-center gap-3 flex-1">
        <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-slate-100 text-[#070B5F]">
          <LifeBuoy size={18} />
        </div>
        <div>
          <div className="font-semibold text-sm text-slate-900">Need help?</div>
          <div className="text-xs text-slate-600">
            Tell us what went wrong or what you could not find.
          </div>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Button variant="outline" size="sm" onClick={() => setFeedbackOpen(true)} data-testid="help-send-feedback">
          <MessageSquare size={14} className="mr-1.5" /> Send feedback
        </Button>
        {contactEmail && (
          <Button asChild variant="outline" size="sm">
            <a href={`mailto:${contactEmail}?subject=${encodeURIComponent('BrokerForYou support')}`} data-testid="help-contact-support">
              <Mail size={14} className="mr-1.5" /> Contact support
            </a>
          </Button>
        )}
      </div>
      <FeedbackDialog open={feedbackOpen} onOpenChange={setFeedbackOpen} />
    </Card>
  );
}
